var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c(
            "el-main",
            { staticStyle: { padding: "0", overflow: "visible" } },
            [
              _c("breadcrumb-login"),
              _vm._v(" "),
              _c("sign-in-section"),
              _vm._v(" "),
              _c("agent-sign-in-section"),
              _vm._v(" "),
              _c("property-icon-set")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-929da826", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-929da826","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/loginLayout.vue
// module id = null
// module chunks = 